import { render, staticRenderFns } from "./RegistEmployees.vue?vue&type=template&id=1db59224&scoped=true&"
import script from "./RegistEmployees.vue?vue&type=script&lang=js&"
export * from "./RegistEmployees.vue?vue&type=script&lang=js&"
import style0 from "./RegistEmployees.vue?vue&type=style&index=0&id=1db59224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db59224",
  null
  
)

export default component.exports